import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import "tailwindcss/tailwind.css";
import { getCookieStateAnalytics } from "./features/app/appSlice";
import { store } from "./app/store";
import App from "./app/App";

const isReactSnap =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

if (!isReactSnap) {
  ReactGA.initialize("G-PN1DSW3WKE");
}

const SendAnalytics = () => {
  if (isReactSnap) return;
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

const RootComponent = () => {
  const analytics = useSelector(getCookieStateAnalytics);
  useEffect(() => {
    if (analytics) {
      reportWebVitals(SendAnalytics);
    }
  }, [analytics]);

  return <App />;
};

const rootElement = document.getElementById("root") as HTMLElement;

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <RootComponent />
    </Provider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}
